import { apiClient } from './apiClient';

const BASE_URL = '/messages';

export class MessageService {
    constructor() {
        this.baseUrl = BASE_URL;
    }


    async sendMessage(messageData) {
        try {
            if (!messageData.orgId) {
                throw new Error('orgId is required');
            }
            if (!messageData.recipients || !Array.isArray(messageData.recipients) || messageData.recipients.length === 0) {
                throw new Error('recipients array is required and must contain at least one recipient');
            }

            // ✅ CHANGE: Allow empty body if attachments exist
            const hasAttachments = messageData.attachments && messageData.attachments.length > 0;
            if (!messageData.templateId && !messageData.body && !hasAttachments) {
                throw new Error('Message body, template, or attachment is required');
            }

            const response = await apiClient.post(this.baseUrl, {
                ...messageData,
                body: messageData.body || "", // Ensure body is at least an empty string
                threadId: messageData.threadId || null
            });
            return response;
        } catch (error) {
            console.error('Error sending message:', error);
            throw error;
        }
    }


    async getThreads(context, contextId, userId) {
        try {
            const response = await apiClient.get(`${this.baseUrl}/threads`, {
                params: { context, contextId, userId } // 👈 ADD `userId` to the params
            });
            return response
        } catch (error) {
            console.error('Error fetching threads:', error);
            throw error;
        }
    }

    async getUnreadMessages(page = 1, limit = 20, userId = null) {
        try {
            const params = { page, limit };
            if (userId) params.userId = userId;

            const response = await apiClient.get(`${this.baseUrl}/unread`, {
                params
            });
            return response;
        } catch (error) {
            console.error('Error fetching unread messages:', error);
            throw error;
        }
    }

    async markMessagesAsRead(payload) {
        try {
            // Note the URL is just '/messages/read', not the base URL variable
            const response = await apiClient.patch(`${BASE_URL}/read`, payload);
            return response;
        } catch (error) {
            console.error('Error marking messages as read:', error);
            throw error;
        }
    }

    async uploadAttachment(file) {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await apiClient.post(`${this.baseUrl}/upload-attachment`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response;
        } catch (error) {
            console.error('Error uploading attachment:', error);
            throw error;
        }
    }

    async downloadAttachment(gcsPath) {
        try {
            // Use apiClient.getBlobData to ensure Authorization header is included
            return await apiClient.getBlobData(`${this.baseUrl}/attachment?path=${encodeURIComponent(gcsPath)}`, {
                responseType: "blob"
            });
        } catch (error) {
            console.error("Error downloading attachment:", error);
            throw error;
        }
    }

}

export const messageService = new MessageService();
export default messageService;
